import React, { useRef } from 'react';
import { getOrganizationsWithSelectedOnTop } from '../utils/getOrganizationsWithSelectedOnTop';

function StepTwo({
    availableOrganizations,
    unavailableOrganizations,
    selectedOrganizationId,
    setSelectedOrganizationId,
    isLoading,
    resourcedTexts,
}) {
    const initialSelectedOrganizationIdRef = useRef(selectedOrganizationId);
    const hasSelectedOrganization = availableOrganizations.some((org) => org.id === selectedOrganizationId);

    function handleSelectOrganization(e) {
        setSelectedOrganizationId(e.target.value);
    }

    const sortedAvailableOrganizations = getOrganizationsWithSelectedOnTop(
        availableOrganizations,
        initialSelectedOrganizationIdRef.current,
    );

    return (
        <div className="login-two">
            <div className="form-field">
                {sortedAvailableOrganizations.map(({ id, name }, i) => (
                    <span className="ktc-radio" key={id}>
                        <input
                            type="radio"
                            name="organization"
                            id={id}
                            value={id}
                            checked={id === selectedOrganizationId}
                            onChange={handleSelectOrganization}
                        />
                        <label htmlFor={id}>{name}</label>
                    </span>
                ))}
            </div>

            <button
                className="login-two__button button primary"
                disabled={!hasSelectedOrganization || isLoading}
            >
                {isLoading ? resourcedTexts.loadingButton : resourcedTexts.selectOrganizationButton}
            </button>

            {unavailableOrganizations.length > 0 && (
                <>
                    <hr />

                    <p className="login-two__unavailable-remark">
                        {resourcedTexts.organizationsUnavailableRemark}
                    </p>

                    <div className="form-field">
                        {unavailableOrganizations.map(({ id, name }) => (
                            <span className="ktc-radio" key={id}>
                                <input
                                    id={id}
                                    value={id}
                                    type="radio"
                                    name="unavailableOrganization"
                                    disabled
                                />
                                <label htmlFor={id}>{name}</label>
                            </span>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}

export { StepTwo };
